import { RemToPx } from 'smg/util';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const $featuredProductsContainers = document.querySelectorAll<HTMLElement>('.home-featured-products-container');
// const $featuredProducts = $featuredProductsContainers?.querySelector<HTMLElement>('.swiper');

$featuredProductsContainers.forEach($featuredProductsContainer => {
    const $featuredProducts = $featuredProductsContainer.querySelector('.swiper') as HTMLElement;

    const updateFeaturedProductsHeight = () => {
        const $cards = $featuredProductsContainer.querySelectorAll<HTMLElement>('.card');
        $cards.forEach($ => $.classList.remove('h-100'));

        const max = Math.max(...Array.from($featuredProductsContainer.querySelectorAll<HTMLElement>('.card')).map($ => $.offsetHeight));
        $featuredProductsContainer.style.setProperty('--max-item-height', `${max}px`);

        $cards.forEach($ => $.classList.add('h-100'));
    };

    updateFeaturedProductsHeight();
    void document.fonts.ready.then(updateFeaturedProductsHeight);

    new Swiper($featuredProducts, {
        modules: [Navigation, Pagination, Autoplay],

        loop: true,
        autoplay: true,

        slidesPerView: 1,
        spaceBetween: RemToPx(2),
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1400: {
                slidesPerView: 4,
            },
        },

        observeParents: true,
        observeSlideChildren: true,
        observer: true,

        on: {
            init: updateFeaturedProductsHeight,

        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});

const $featuredBrandsContainers = document.querySelectorAll<HTMLElement>('.home-featured-brands-container');
$featuredBrandsContainers.forEach($featuredBrandsContainer => {
    const $featuredBrands = $featuredBrandsContainer.querySelector('.swiper') as HTMLElement;

    new Swiper($featuredBrands, {
        modules: [Navigation, Pagination, Autoplay],

        loop: true,
        autoplay: true,

        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: RemToPx(2),

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});